var _style, _path, _path2, _circle, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fullscreen_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fullscreen_svg__st4,.fullscreen_svg__st5{fill:none;stroke:#35a4dd;stroke-width:65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.fullscreen_svg__st5{stroke:#f9af17}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M986 37.1L482 542.2M692.4 36.4h294.2M986.7 331.3l-.2-294.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1 274.3v712.1h807.6V354.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.1,
    cy: 178.9,
    r: 32.6,
    fill: "#35a4dd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M651.3 178.9h-517"
  })));
}

export default SvgFullscreen;